import { ThemeProvider } from '@mui/material/styles';
import { createContext, FC, useContext, useEffect, useMemo, useState } from 'react';

import composeTheme from '@theme/theme';
import { ThemeMode } from '@theme/palettes/PaletteOptions.interface';

interface IColorModeContext {
  toggleMode: () => void;
  mode: ThemeMode;
}

export const ColorModeContext = createContext<IColorModeContext>({
  toggleMode: () => {},
  mode: 'light',
});

interface Props {
  children: React.ReactNode;
}

// EC: look into what this is doing/if needed in new theme land
export const ColorModeContextProvider: FC<Props> = ({ children }) => {
  const [mode, setMode] = useState<ThemeMode>('dark');

  const colorMode = useMemo(
    () => ({
      toggleMode: () => {
        if (mode === 'light') {
          localStorage.setItem('@theme', 'dark');
          setMode('dark');
        } else {
          localStorage.setItem('@theme', 'light');
          setMode('light');
        }
      },
      mode,
    }),
    [mode],
  );

  useEffect(() => {
    const localTheme = localStorage.getItem('@theme') as ThemeMode;
    if (localTheme && localTheme !== 'light') {
      setMode(localTheme);
    }
  }, []);

  const theme = useMemo(() => composeTheme(mode), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export const useColorMode = () => useContext(ColorModeContext);
